<template>
  <generic-modal
    :title="$t('archive.expedient_details')"
    :buttons="buttons"
    ref="generic_modal"
  >
    <div v-if="meta.expedient_id">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.expedient_number") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="meta.expedient_number"
                readonly
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.customer") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="meta.customer?.name"
                readonly
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.expedient_name") }}</label>
            <div class="control">
              <input class="input" type="text" :value="meta.name" readonly />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.description") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                :value="meta.description"
                readonly
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.status") }}</label>
            <div class="control">
              <span class="tag is-large" :class="getStatusClass(meta.status)">
                {{ $t("archive.status_" + meta.status) }}
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.priority") }}</label>
            <div class="control">
              <span
                class="tag is-large"
                :class="getPriorityClass(meta.priority)"
              >
                {{ $t("archive.priority_" + meta.priority) }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.notes") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                :value="meta.notes"
                readonly
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.file_count") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="meta.file_count || 0"
                readonly
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("create_date") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="format_date(meta.create_date)"
                readonly
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>

<script>
import {
  error_message,
  get,
  generate_error_message_text,
  format_date,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ExpedientDetailModal",
  components: {
    GenericModal,
  },
  data() {
    return {
      buttons: [
        {
          text: this.$t("edit"),
          class: "is-primary is-rounded",
          icon: "fa fa-edit",
          click: this.edit_expedient,
          visible: "this.meta.expedient_id",
        },
        {
          text: this.$t("close"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
    };
  },
  methods: {
    format_date,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show(expedient_id) {
      let v = this;
      v.set_initial_state();
      v.load_expedient(expedient_id);
      v.$refs.generic_modal.show_modal();
    },
    async load_expedient(uuid) {
      let v = this;
      try {
        let expedient = await get("/archive/expedient", { uuid: uuid });
        v.meta = expedient;
      } catch (error) {
        v.error = generate_error_message_text(error);
      }
    },
    edit_expedient() {
      let v = this;
      v.$emit("edit", v.meta);
      v.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
    },
    getStatusClass(status) {
      const statusColors = {
        active: "is-success",
        pending: "is-warning",
        closed: "is-dark",
        archived: "is-light",
      };
      return statusColors[status] || "is-light";
    },
    getPriorityClass(priority) {
      const priorityColors = {
        low: "is-info",
        medium: "is-primary",
        high: "is-warning",
        urgent: "is-danger",
      };
      return priorityColors[priority] || "is-light";
    },
  },
};
</script>

<style>
.field {
  margin-bottom: 1rem;
}

.textarea {
  resize: none;
}

.tag.is-large {
  font-size: 1rem;
  padding: 0.5rem 1rem;
}
</style>
